import { Model } from '@vuex-orm/core'
import { CREATABLE_ROLES } from '@/lib/constants'
import Role from '@/store/models/Role'

export default class User extends Model {
  static entity = 'users'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      email: this.string(''),
      firstName: this.string(''),
      lastName: this.string(''),
      defaultOrganizationId: this.attr(null),
      currentOrganizationRoleId: this.attr(null),
      meta: this.attr(null),
      favoriteUsers: this.attr(null),
    }
  }

  static permitAttributes = [
    'email',
    'firstName',
    'lastName'
  ]

  static skeleton() {
    return Object.fromEntries(
      Object.entries(this.fields())
      .map(([_, object]) => [_, object.value])
      .filter(([key]) => this.permitAttributes.includes(key))
    )
  }

  get creatable() {
    const currentOrganizationRole = Role.find(this.currentOrganizationRoleId)
    return currentOrganizationRole && CREATABLE_ROLES.includes(currentOrganizationRole.roleType)
  }
}
